/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Declinedcount1Inputs */

const de__field_declinedcount1 = /** @type {(inputs: _Field_Declinedcount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl abgesagter Teilnahmen`)
};

/**

* @param {_Field_Declinedcount1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_declinedcount1 = /** @type {((inputs?: _Field_Declinedcount1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Declinedcount1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_declinedcount1(inputs)
});
export { _field_declinedcount1 as "_field_declinedCount" }